import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BlogArticle = {
  title: string;
  subtitle: string;
  content: string;
  imageUrl?: string;
  image_url?: string;
  source?: string;
  sourceUrl?: string;
  source_url?: string;
  arxiv_id?: string;
  authors?: string[];
  published_date?: string;
  tags?: string[];
  category?: string;
  featured?: boolean;
  id?: string;
  original_title?: string;
  original_abstract?: string;
};

type BlogState = { article: BlogArticle | null };

const initialState: BlogState = { article: null };

export const blogSlice = createSlice({
  name: "blog",
  initialState,
  reducers: {
    setBlogArticle(state, action: PayloadAction<BlogArticle | null>) {
      state.article = action.payload;
    },
  },
});

export const { setBlogArticle } = blogSlice.actions;

export default blogSlice.reducer;
